import { render, staticRenderFns } from "./NewTicket.vue?vue&type=template&id=89e09ffa&"
import script from "./NewTicket.vue?vue&type=script&lang=js&"
export * from "./NewTicket.vue?vue&type=script&lang=js&"
import style0 from "./NewTicket.vue?vue&type=style&index=0&id=89e09ffa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports